module.exports = __webpack_public_path__ + "static/media/desde1995.b09b2a41.png";